import { compact } from "lodash";
import { ColumnType } from "antd/lib/table";
import { EMPTY } from "constants/common";
import { AiccCanDoStatement, AiccVocabularyWord } from "types/model/aiccCustomer";

export const getVocabularyColumns = (hasTransliteration: boolean): ColumnType<AiccVocabularyWord>[] =>
  compact([
    {
      title: "Word",
      dataIndex: "word",
      key: "word",
      width: 240,
      render: (_, { word }) => word || EMPTY,
    },
    hasTransliteration && {
      title: "Transliteration",
      dataIndex: "transliteration",
      key: "transliteration",
      width: 240,
      render: (_, { transliteration }) => transliteration || EMPTY,
    },
    {
      title: "Translation",
      dataIndex: "translation",
      key: "translation",
      width: 320,
      render: (_, { translation }) => translation || EMPTY,
    },
    {
      title: "Uses",
      dataIndex: "uses",
      key: "uses",
      width: 100,
    },
  ]);

export const canDoColumns: ColumnType<AiccCanDoStatement>[] = [
  {
    title: "Fluency Level",
    dataIndex: "fluencyLevel",
    key: "fluencyLevel",
    width: 140,
  },
  {
    title: "Statement",
    dataIndex: "statement",
    key: "statement",
    render: (_, { statement }) => statement || EMPTY,
  },
  {
    title: "Uses",
    dataIndex: "uses",
    key: "uses",
    width: 100,
  },
];
